<template>
  <div>
    <div class="bg"></div>
    <Tabs :navs="navs" :single="singleArr" @show="ifShow = true" @hide="ifShow = false"></Tabs>
    <div :class="ifShow ? '' : 'opacity-0'">
      <div
        v-for="(item, index) of navs"
        :key="index"
        :id="item.id"
        class="nav-item">
        <div v-if="index != 6" class="main">
          <img v-show="ifShow" :src="item.imgSrc" class="nav-item-img" />
        </div>
      </div>
    </div>
    <div :class="ifShow ? 'opacity-0' : ''" class="main">
      <div v-for="(item, index) of newsList" :key="index" class="ten_news_list ten_news_items" data-lazy="10" data-lazy-threshold="0.9" @click="showDialog(item.article_id)">
        <div class="ten_news_item" style="display: flex;">
          <div class="ten_news_item_txt">
            <div class="pointer">
              <div class="ten_tagline">
                <div style="padding-top: 3px">{{ parseTime(item.article_addtime) }}</div>
              </div>
              <h3>{{item.article_title}}</h3>
              <p>{{item.article_intro}}</p>
            </div>
          </div>
          <div class="ten_news_item_img">
            <div class="pointer">
              <div class="ten_img">
                <img :src="item.article_pic_big">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from "@/views/components/tabs";
import { parseTime } from "@/utils/data";
export default {
    components: { Tabs },
    mounted() {
      this.getNewList();
    },
    data(){
        return{
            navs: [
                { name: '公司简介', id: 'gongsijianjie', imgSrc: require("../../assets/about/1.png") },
                { name: '发展历程', id: 'fazhanlicheng', imgSrc: require("../../assets/about/2.png") },
                { name: '超级生产线', id: 'chaojishengchanxian', imgSrc: require("../../assets/about/3.png") },
                { name: '研发团队', id: 'yanfatuandui', imgSrc: require("../../assets/about/4.png") },
                { name: '精细管理', id: 'jingxiguanli', imgSrc: require("../../assets/about/5.png") },
                { name: '工程案例', id: 'gongchenganli', imgSrc: require("../../assets/about/6.png") },
                { name: '新闻发布', id: 'xinwenfabu'},
            ],
            newsList: [],
            singleArr: ['xinwenfabu'],
            ifShow: true,
        }
    },
    methods: {
      async getNewList() {
        let res = await request({
          url: `/api.php?app=ajax&app_act=newsList`,
          method: "get",
        });
        this.newsList = res.data.data;
        // this.newsList.forEach(item => {
        //   item.article_pic_big = require(`${item.article_pic_big}`);
        // })
      },
      parseTime,
    }
}
</script>

<style lang='scss' scoped>
    .bg{
        background: url("../../assets/about/bg.jpg") no-repeat center center;
        background-size: cover;
        width: 100%;
        height: 500px;
    }
    .main {
        width: 1280px;
        margin: 0 auto;
    }
    .opacity-0 {
      height: 0;
    }
    .bg-gray {
        background-color: #FBFBFB ;
    }
    .nav-item {
      .nav-item-img {
        width: 100%;
        background-size: cover;
      }
    }
    .ten_tagline,
    .ten_tagline--fill{
        overflow: hidden;
        font-size:14px;
        line-height: 24px; height: 30px;
        display: inline-block;
        position: relative;
        border-top:1px solid rgba(25,74,195,1);
        padding:0px 30px;
        color: rgba(25,74,195,1);
    }
    .ten_tagline:before,
    .ten_tagline--fill:before{
        content: "";
        display: block;
        position: absolute;
        left: calc(100% - 12px);
        bottom: 0px; width: 100%;
        border-top:1px solid rgba(25,74,195,1);
        transform: rotate(-69deg) translate(-1px,0px);
        transform-origin: 0px 0px;
    }
    .ten_tagline:after,
    .ten_tagline--fill:after{
        content: "";
        display: block;
        position: absolute;
        left: 0px;
        bottom: 0px;
        width: calc(100% - 12px);
        border-top:1px solid rgba(25,74,195,1);
    }

    .ten_tagline--fill{ color: #FFF; }
    .ten_tagline--fill:before{
        background: rgba(25,74,195,1);
        height: 36px;
        transform-origin: 0px 100%;
    }
    .ten_tagline--fill:after{
        background: rgba(25,74,195,1); height: 36px;
    }
    .ten_tagline--fill span{ position: relative; z-index: 1;}
    .ten_news_item{  display: flex; justify-content: space-between; align-items: center; margin: 60px 0px; padding: 10px 0; border-bottom: 1px solid #f4f4f4; }
    .ten_news_item h3{
      font-weight: 600;
      &:hover {
        color: rgba(25,74,195,1);
      }
      }
    .ten_news_item_txt{ width: calc(60% - 72px); }
    .ten_news_item_img{width: calc(40% - 0px);}
    .ten_news_item_txt--full{ width: 100%; }

    .ten_news_item_txt .ten_tagline{ border-left: 1px solid rgba(25,74,195,1); }
    .ten_news_item_txt a:hover h3{ color: rgba(25,74,195,1); }

    .ten_news_item_txt h3{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
    }
    .ten_news_item_txt p{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
    }
    a {
      text-decoration: none;
      color: inherit;
      cursor: pointer;
    }
    .ten_img {
      img {
        width: 100%;
        height: 240px;
        object-fit: cover;
      }
    }
</style>